<template>
  <div class="input">
    <InputWrapper :label="label">
      <input
        v-model="value"
        class="input__input"
        :class="{ '-error': error }"
        :type="type"
        :placeholder="placeholder"
        :maxlength="maxlength"
      />
    </InputWrapper>
  </div>
</template>

<script>
import InputWrapper from "./InputWrapper";

export default {
  name: "Input",
  data() {
    return {
      value: ""
    };
  },
  components: {
    InputWrapper
  },
  props: {
    label: {
      type: String,
      default: undefined,
      required: false
    },
    type: {
      type: String,
      default: "text",
      required: false
    },
    placeholder: {
      type: String,
      default: undefined,
      required: false
    },
    maxlength: {
      type: String,
      default: undefined,
      required: false
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: function(val) {
      this.$emit("value", val);
    }
  }
};
</script>

<style lang="scss" scoped>
.input {
  display: block;
  position: relative;
  width: 100%;

  &__label {
    color: theme-color("body");
    font-size: px-to-rem(16px);
    margin-bottom: spacer("s");
  }

  &__input {
    border-radius: sizes("border-radius");
    border: 0;
    box-shadow: theme-color("shadow");
    font-family: $font-family;
    font-size: px-to-rem(16px);
    padding: 18px;
    position: relative;
    transition: cta-transition(box-shadow);
    width: 100%;

    @include if-tablet {
      font-size: px-to-rem(18px);
    }

    &::placeholder {
      color: theme-color("inactive");
    }

    &.-error {
      box-shadow: theme-color("shadow-error");
    }
  }
}
</style>
